export default __webpack_public_path__ + "static/media/mosh-negative.4e40b7e6.svg";